import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

export type ListPaginationProps = {
  readonly page: number;
  readonly pages: number;
  readonly onChange: (_page: number) => void;
};

/**
 * 前へ / 次へ だけのページ送り。件数の多い一覧は絞り込みで狭める前提なので、
 * ページ番号の羅列は持たない。
 */
export function ListPagination({ page, pages, onChange }: ListPaginationProps) {
  const { t } = useTranslation("common");

  if (pages <= 1) return null;

  return (
    <nav className="flex items-center justify-end gap-3 text-sm">
      <Button
        type="button"
        size="sm"
        variant="outline"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
      >
        {t("pagination.previous")}
      </Button>
      <span className="text-muted-foreground tabular-nums">
        {page} / {pages}
      </span>
      <Button
        type="button"
        size="sm"
        variant="outline"
        disabled={page >= pages}
        onClick={() => onChange(page + 1)}
      >
        {t("pagination.next")}
      </Button>
    </nav>
  );
}
